module.exports = __webpack_public_path__ + "img/2_264.51448963.png";